(function () {
  'use strict';

  if (window.TanteTestimonialsCarousel) {
    window.TanteTestimonialsCarousel.initAll(document);
    return;
  }

  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var DURATION = 550;

  function cloneTemplate(root, selector) {
    var template = root.querySelector(selector) || document.querySelector(selector);

    if (!template || !template.content || !template.content.firstElementChild) {
      return null;
    }

    return template.content.firstElementChild.cloneNode(true);
  }

  function initCarousel(root) {
    if (!root || root.dataset.tanteCarouselReady === 'true') return;

    var track = root.querySelector('.testimonial__list');
    var photos = Array.prototype.slice.call(
      root.querySelectorAll('.testimonial__list .testimonial__item')
    );
    var quotes = Array.prototype.slice.call(
      root.querySelectorAll('.testimonial__previews .testimonial__preview')
    );
    var count = photos.length;
    if (!track || count === 0) return;

    root.dataset.tanteCarouselReady = 'true';

    var center = Math.floor(count / 2);
    var active = 0;
    var autorotate = root.dataset.autorotate === 'true';
    var speed = parseInt(root.dataset.autorotateSpeed, 10) || 5000;
    var timer = null;
    var animToken = 0;

    // --- Navigation arrows ---
    var arrowHost = root.querySelector('.testimonial__list-wrapper') || root;
    function makeArrow(dir, label) {
      var btn = cloneTemplate(
        root,
        'template[data-tante-testimonial-arrow-template="' + dir + '"]'
      );

      if (!btn) {
        btn = document.createElement('button');
        btn.textContent = dir === 'prev' ? '<' : '>';
      }

      btn.type = 'button';
      btn.classList.add('tante-testimonial__arrow', 'tante-testimonial__arrow--' + dir);
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', label);
      }
      btn.addEventListener('click', function () {
        var step = dir === 'prev' ? -1 : 1;
        go(active + step, step);
      });
      return btn;
    }
    arrowHost.appendChild(makeArrow('prev', 'Previous'));
    arrowHost.appendChild(makeArrow('next', 'Next'));

    // --- Pagination dots ---
    var dotsWrap = cloneTemplate(root, 'template[data-tante-testimonial-dots-template]');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
    }
    dotsWrap.classList.add('tante-testimonial__dots');
    var dots = photos.map(function (_, i) {
      var dot = cloneTemplate(root, 'template[data-tante-testimonial-dot-template]');
      if (!dot) {
        dot = document.createElement('button');
      }
      dot.type = 'button';
      dot.classList.add('tante-testimonial__dot');
      dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
      dot.addEventListener('click', function () {
        go(i);
      });
      dotsWrap.appendChild(dot);
      return dot;
    });
    var previews = root.querySelector('.testimonial__previews');
    if (previews && previews.parentNode) {
      previews.parentNode.insertBefore(dotsWrap, previews.nextSibling);
    } else {
      root.appendChild(dotsWrap);
    }

    // --- Click a side photo to bring it to centre ---
    photos.forEach(function (photo, i) {
      photo.addEventListener('click', function () {
        if (i !== active) go(i);
      });
    });

    // Apply the resting layout for the current active index (no animation).
    function applyState() {
      photos.forEach(function (photo, i) {
        var order = (((i - active + center) % count) + count) % count;
        photo.style.order = String(order);
        photo.classList.toggle('is-selected', i === active);
      });
      quotes.forEach(function (quote, i) {
        quote.classList.toggle('is-selected', i === active);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-selected', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }

    // FLIP: First (measure) -> Last (re-layout) -> Invert -> Play (transition).
    // `dir` is the travel direction: +1 forward (a new circle enters from the
    // right), -1 backward (enters from the left). Defaults to the shortest path.
    function go(index, dir) {
      var next = (((index % count) + count) % count);
      if (next === active) return;

      if (dir === undefined) {
        var fwd = ((next - active) % count + count) % count;
        var bwd = ((active - next) % count + count) % count;
        dir = fwd <= bwd ? 1 : -1;
      }

      // First: current on-screen position (includes any in-flight transform).
      var firsts = photos.map(function (p) {
        return p.getBoundingClientRect();
      });
      var oldOrders = photos.map(function (p) {
        return parseInt(p.style.order, 10) || 0;
      });

      active = next;
      applyState();

      // Last: clear transforms so we read the true resting positions.
      photos.forEach(function (p) {
        p.style.transition = 'none';
        p.style.transform = '';
      });
      void track.offsetWidth;
      var lasts = photos.map(function (p) {
        return p.getBoundingClientRect();
      });

      var wrapRect = arrowHost.getBoundingClientRect();

      // Invert: place every photo at its previous spot; the circle that wraps
      // to the far end starts just off the entering edge so it slides in
      // smoothly instead of popping or flying across the whole strip.
      photos.forEach(function (p, i) {
        var newOrder = parseInt(p.style.order, 10) || 0;
        var wrapped = Math.abs(newOrder - oldOrders[i]) > center;
        var last = lasts[i];
        if (wrapped) {
          var tx =
            dir > 0
              ? wrapRect.right - last.left + 20
              : wrapRect.left - last.right - 20;
          p.style.transform = 'translateX(' + tx + 'px)';
        } else {
          var f = firsts[i];
          var dx = f.left + f.width / 2 - (last.left + last.width / 2);
          var dy = f.top + f.height / 2 - (last.top + last.height / 2);
          var s = last.width ? f.width / last.width : 1;
          p.style.transform =
            'translate(' + dx + 'px, ' + dy + 'px) scale(' + s + ')';
        }
      });

      // Force a reflow so the inverted start positions are committed.
      void track.offsetWidth;

      // Play: release every photo to its resting spot. Transition to an
      // explicit identity matrix (not `none`) — matrix->none doesn't
      // interpolate reliably and can leave the photo frozen mid-slide.
      var myToken = ++animToken;
      photos.forEach(function (p) {
        p.style.transition = 'transform ' + DURATION + 'ms ' + EASE;
        p.style.transform = 'translate(0px, 0px) scale(1)';
      });
      window.setTimeout(function () {
        if (myToken !== animToken) return; // a newer slide started; leave it
        photos.forEach(function (p) {
          p.style.transition = '';
          p.style.transform = '';
        });
      }, DURATION + 30);

      restart();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      if (autorotate && count > 1) {
        timer = setInterval(function () {
          go(active + 1, 1);
        }, speed);
      }
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);

    applyState();
    restart();
  }

  function initAll(context) {
    var scope = context || document;

    if (scope.matches && scope.matches('[data-tante-carousel]')) {
      initCarousel(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-tante-carousel]'),
      initCarousel
    );
  }

  window.TanteTestimonialsCarousel = {
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
